export default defineNuxtPlugin({
  name: 'gtmUsernameVariable',
  parallel: true,
  setup () {
    const gtm = useGtm();

    const userState = useUserState();

    watch(userState, (newUserState) => {
      if (newUserState) {
        gtm?.push({ username: newUserState.email });
      }
    }, { immediate: true });
  }
});
